import React from 'react';
import _UserInfo from './_UserInfo.scss';
import { CustomEditableText as EditableText } from 'components/UI';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {User} from 'api';
import {toastr} from 'react-redux-toastr';
import {SingleImageUploader} from 'components/uploader';

class UserInfo extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      fullname: this.props.auth && this.props.auth.isAuthenticated && this.props.auth.user.fullname || '',
      phone: this.props.auth && this.props.auth.isAuthenticated && this.props.auth.user.phone || '',
      address: this.props.auth && this.props.auth.isAuthenticated && this.props.auth.user.address || '',
      email: this.props.auth && this.props.auth.isAuthenticated && this.props.auth.user.email || '',
      avatar: this.props.auth && this.props.auth.isAuthenticated && this.props.auth.user.avatar || ''
    }
  }

  onUploadComplete(image) {
    this.setState({
      avatar: image.name
    });

    this.updateField('avatar', image.name);
  }

  updateField(name, value, forceEmpty = false) {
    if ((value || forceEmpty) && value != this.props.auth.user[name]) {
      this.props.dispatch(User.actions.update({id: this.props.auth.user.id}, {
        data: {
          [name]: value
        }
      }))
      .then(response => {
        this.props.dispatch({
          type: 'CURRENT_USER',
          user: response.data
        });

        toastr.removeByType('success');
        toastr.success('Thành công', 'Thông tin cá nhân đã được cập nhật thành công');
      }).
      catch(err => {
        console.log(err);

        toastr.removeByType('error');
        toastr.error('Lỗi', 'Có lỗi xảy ra. Bạn vui lòng kiểm tra lại thông tin');
      });
    }
  }

  removeImage() {
    this.updateField('avatar', '', true);
  }

  render() {
    return (
      <div>
        <div className="row">
          <div className="user-info-left-wrap">
            <div className='user-info-upload-img-wrap'>
              <SingleImageUploader fnUpload={User.actions.uploadAvatar.request}
                title="Ảnh cá nhân"
                type="USER"
                image={this.state.avatar}
                onRemoveImage={this.removeImage.bind(this)}
                onUploadComplete={this.onUploadComplete.bind(this)}
                confirmRemove={true}
              />
            </div>

            <div className="user-info-left box-wrap">

              <EditableText value={this.state.fullname} label='Tên'
                placeholder="Tên ..."
                textClassName='fa fa-user-o form-control-feedback'
                onUpdate={this.updateField.bind(this, 'fullname')}
              />
              <EditableText value={this.state.phone} label='Điện thoại'
                placeholder="Điện thoại ..."
                textClassName='glyphicon glyphicon-user form-control-feedback'
                onUpdate={this.updateField.bind(this, 'phone')}
              />
              <EditableText value={this.state.address} label='Địa chỉ'
                placeholder="Địa chỉ ..."
                textClassName='fa fa-map-marker form-control-feedback'
                onUpdate={this.updateField.bind(this, 'address')}
              />
            </div>
          </div>
          <div className="user-info-right-wrap">
            <div className="box-wrap user-info-right">
              <h2 className="user-content">Email: {this.state.email}</h2>
              <a href="#" className="update-link">Đổi email</a>
            </div>
            <div className="box-wrap user-info-right">
              <h2 className="user-content">Mật khẩu: *******</h2>
              <Link to="/user/change-pass" className="update-link">Đổi mật khẩu</Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const bindStateToProps = state => {
  return {
    auth: state.auth
  }
}

export default connect(bindStateToProps)(UserInfo);



// WEBPACK FOOTER //
// ./components/users/sub-view/user-info/UserInfo.jsx